import { render } from "./BaseListWrapper.vue?vue&type=template&id=21cd632c&scoped=true"
import script from "./BaseListWrapper.vue?vue&type=script&lang=js"
export * from "./BaseListWrapper.vue?vue&type=script&lang=js"

import "./BaseListWrapper.vue?vue&type=style&index=0&id=21cd632c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cd632c"]])

export default __exports__